














































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { mapState, mapActions } from 'vuex';
import { STORE_KEY, store } from './_store';

@Component({
  computed: {
    ...mapState(STORE_KEY, [
      'loaded',
      'loading',
      'fatalError',
      'document',
      'form',
      'schemaOptions',
      'connectionConfigured'
    ])
  },
  methods: {
    ...mapActions(STORE_KEY, ['init', 'saveForm', 'changeFormValue'])
  }
})
export default class DbSyncConfigForm extends Vue {
  @Prop({ default: null }) documentId!: string | null;

  loaded!: boolean;
  loading!: boolean;
  fatalError!: boolean;
  form!: any;
  schemaOptions!: any[];
  connectionConfigured!: boolean;
  init!: (params: any) => Promise<any>;
  saveForm!: (documentId: string | null) => Promise<any>;

  created() {
    if (!(this.$store as any).hasModule(STORE_KEY)) {
      this.$store.registerModule(STORE_KEY, store);
    }
    this.init({ documentId: this.documentId });
  }

  beforeDestroy() {
    if ((this.$store as any).hasModule(STORE_KEY)) {
      this.$store.unregisterModule(STORE_KEY);
    }
  }

  save() {
    this.saveForm(this.documentId)
      .then(() => {
        this.$emit('saved');
        (this.$parent as any).close();
      })
      .catch(() => {
        this.$buefy.toast.open({
          message: 'Ошибка сохранения',
          type: 'is-danger'
        });
      });
  }
}
